/** Konfiguracija iz Vite okruženja (build-time). */
export const env = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) || 'http://localhost:8080',
  mock: import.meta.env.VITE_MOCK === '1',
  turnstileSiteKey: (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) || '',
  /** Sentry je isključen (SDK se ne učitava) dok DSN nije postavljen. */
  sentryDsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) || '',
  sentryEnvironment:
    (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) || import.meta.env.MODE,
  sentryTracesSampleRate: rate(
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
    import.meta.env.PROD,
  ),
} as const;

/** Udio uzorkovanih transakcija: zadato, inače 0,1 u produkcionom buildu i 0 u razvoju. */
function rate(v: string | undefined, prod: boolean): number {
  const n = v === undefined || v === '' ? NaN : Number(v);
  if (Number.isFinite(n) && n >= 0 && n <= 1) return n;
  return prod ? 0.1 : 0;
}
